var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1128.88 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .warning3fil0 {fill:black}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M495.65 5.47c-322.97,43.98 -530.9,326.68 -490.7,630.88 41.17,311.47 327.71,529.75 631.26,486.79 318.12,-45.03 530.31,-334.21 487.09,-631.64 -45.35,-312.12 -322.72,-527.56 -627.65,-486.03zm11.61 54.68c-157.32,22.05 -259.68,92.91 -333.81,178.74 -73.31,84.87 -131.66,230.77 -113.45,385.11 30.34,257.1 265.67,479.37 565.38,443.57 257.24,-30.73 478.07,-265.9 442.57,-563.74 -18.91,-158.54 -99.04,-258.11 -179.88,-329.43 -79.89,-70.47 -228.81,-135.56 -380.81,-114.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M512.76 233.11c-10.92,37.38 -10.8,372.99 1.37,408.04 26.2,11.36 72.37,10.63 100.47,0.68 11.92,-41.04 11.46,-362.61 1.35,-408.72 -32.49,-11.2 -77.12,-11.54 -103.19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M512.76 769c-8.55,29.28 -7.5,68.15 0,98.38 29.81,10.32 74.03,10.52 101.84,-0.66 9.6,-27.2 7.96,-67.59 1.35,-97.72 -26.82,-10.38 -75.53,-12.12 -103.19,0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning3);
export default __webpack_public_path__ + "static/media/warning3.a9ae35d1eff631cfdd6d3873d8acf4cb.svg";
export { ForwardRef as ReactComponent };